import { isDefined } from '../../../utils/isDefined';
import mapNumberToDisplay from '../../../utils/mapNumberToDisplay';

export function mapCellNumber(number) {
  return isDefined(number)
    ? mapNumberToDisplay(number.toString().replace('+', ''))
    : null;
}

